const CONSTANTS = {
  SERVER_ERROR: 'SERVER_ERROR',
  CREATE_TICKET: 'CLICK_CREATE_TICKET',
  TICKET_CREATED: 'TICKET_CREATED',
  REQUEST_FLOW: 'REQUEST_FLOW',
  ERROR_FETCHING_ARTICLE: 'ERROR_FETCHING_ARTICLE',
  CREATED_EMAIL: 'CREATED_EMAIL',
  CREATED_CHAT: 'CREATED_CHAT',
  CREATED_WHATSAPP: 'CREATED_WHATSAPP',
  CREATED_CALL: 'CREATED_CALL',
  TICKET_ALREADY_EXIST: 'TICKET_ALREADY_EXIST',
  FIREBASE_AUTH_FAILED: 'FIREBASE_AUTH_FAILED',
  FIREBASE_GET_SCREEN: 'GET_FIREBASE_SCREEN',
  FIREBASE_GET_SCREEN_ERROR: 'FIREBASE_GET_SCREEN_ERROR',
  FIREBASE_AUTH_ERROR: 'FIREBASE_AUTH_ERROR',
  FIREBASE_GET_DATABASES_ERROR: 'FIREBASE_GET_DATABASES_ERROR',
  RATING_CREATED: 'RATING_CREATED',
  RAING_FAILED: 'RATING_FAILED'
}

export default CONSTANTS
